import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 1400px;

  margin: 0 auto;
  margin-bottom: 1rem;
  background: #FFF;
  border: 1px solid var(--light-blue);
  border-radius: .25rem;

  animation: fade 1s;

  &:last-child {
    margin-bottom: 0;
  }

  .left-side {
    padding: .8rem;
  }

  .validate-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0;

    h2 {
      margin-bottom: 1rem;
    }

    p {
      text-align: center;
    }

    p + p {
      margin: .5rem 0 1rem;
    }

    .footer-buttons {
      width: 100%;
      padding: 0 2rem;
      display: flex;
      justify-content: space-between;

      button {
        padding: 4px 0;
        width: 40%;
        background: #FFF;
        border-radius: 8px;
        border: 2px solid #6F6F6F;
        /* box-shadow: 0px 4px 8px #999; */
        color: var(--color-cancel);
        font-weight: bold;
        font-size: 1rem;
        transition: 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 4px 8px rgba(0,0,0,.6);
        }

        &:last-child {
          color: #FFF;
          background: var(--light-green);
          border: var(--light-green);
        }
      }
    }
  }

  .middle-side {
    border-right: 1px solid var(--light-blue);
    border-left: 1px solid var(--light-blue);
    padding: .8rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: flex-start;
    justify-content: flex-start;

    img {
      width: 28px;
      height: 28px;
    }

    .first-line {
      display: flex;
      align-items: center;
      padding-bottom: 1rem;

      .mission-title {
        margin-left: 5px;
      }
    }

    .details-line {
      display: flex;
      width: 100%;
      padding-right: 1rem;
      justify-content: space-between;
      align-items: center;

      .goal, .duration, .skill {
        display: flex;
        align-items: center;

        .flex-detail {
          margin-left: 5px;
        }
      }
    }
  }

  .right-side {
    padding: .8rem;
    height: 100%;

    .status-div {
      display: flex;
      gap: .25rem;
    }
  }

  .validate-mission {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media (max-width: 980px) {
    display: flex;
    flex-direction: column;
    
    .left-side {
      display: none;
    }

    .right-side {
      display: flex;
      align-items: flex-start;
      gap: 0.25rem;
      justify-content: space-between;
      width: 100%;
      position: relative;
      height: 5.5rem;
      
      .validate-mission {
        display: flex;
        flex-direction: row;
        position: absolute;
        width: 42%;
        bottom: .5rem;
      }

      div {
        display: flex;
        flex-direction: column;
        gap: 0 !important;
      }
    }

    .middle-side {
      border-left: 0;
      border-right: 0;
      width: 100%;
      border-bottom: 1px solid var(--light-blue);

      img {
        width: 24px;
        height: 24px;
      }
    }
    .first-line {
      padding-bottom: .25rem !important;
    }

    .goal, .duration {
      padding-bottom: .25rem !important;
    }

    .details-line {
      display: flex;
      flex-direction: column;
      align-items: flex-start !important;
    }
  }


`;

export const Checkbox = styled.button`
  width: 100%;
  animation: fade 1s;
  transition: background .2s;
  background: none;
  outline: 0;
  border: 2px solid var(--light-green);
  border-radius: 4px;
  height: 20px;
  width: 20px;

  &:hover {
    background: var(--light-gray);
  }

  ${props => props.isActive && css`
    display: flex;
    align-items: center;
    background: var(--light-green);
  `}
`;
